import type { SystemStyleObject } from "@mui/system";

import { type Theme, alpha } from "@mui/material";

export const SHEET_TRANSITION_MS = 250;

/** The paper shared by the preview modal and its sheets. */
export const sheetPaper = (theme: Theme): SystemStyleObject<Theme> => ({
  maxWidth: "calc(100% - 32px)",
  m: 2,
  boxShadow: `0 24px 64px ${alpha(theme.palette.common.black, 0.24)}`,
});

export const sheetBackdrop = (theme: Theme): SystemStyleObject<Theme> => ({
  background: alpha(theme.palette.oscar.light.content.content1, 0.32),
});
